var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('guard',{attrs:{"if-admin":_vm.getGuardFuncionalities}},[_c('is-loading',{attrs:{"if":_vm.isLoading}},[_c('has-request-error',{attrs:{"has-error":_vm.requestError,"is-loading":_vm.isReloading},on:{"retry":function($event){return _vm.reloadData()}}},[_c('multilevel-sortable-list',{attrs:{"initial-data":_vm.sortableData,"reorder":_vm.reorder,"sortable-item-name":_vm.$t(
            _vm.isOption
              ? '_.product_options'
              : _vm.isAttribute
              ? '_.product_attributes'
              : '_.products'
          ),"type":_vm.isOption
            ? 'product_options'
            : _vm.isAttribute
            ? 'product_attributes'
            : 'products',"item-name":_vm.$t(
            _vm.isOption
              ? '_.product_option'
              : _vm.isAttribute
              ? '_.product_attribute'
              : '_.product'
          ),"load-items":_vm.loadItems,"limit":_vm.limit,"create-subcategory":_vm.createSubcategory,"create-item":_vm.createItem,"confirm-delete":_vm.confirmDelete,"view":_vm.view,"route-name":_vm.getProductRouteName,"scope":_vm.scope,"duplicate-item":_vm.startProductDuplication},on:{"openCloseCategory":_vm.openCloseCategory}},[_c('template',{slot:"empty"},[_c('no-results',{attrs:{"icon":"exclamation-circle","title":_vm.i18n.emptyResultsTitle,"message":_vm.i18n.emptyResultsMsg}})],1)],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }